import memoize from 'lodash/memoize';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

const hashFn = args => JSON.stringify(args);

const checkAndFormatHit = memoize((text, hit) => {
  if (!text) {
    return null;
  }

  const BFR = 2; // count of words before match
  const AFTR = 10; // count of words after match

  let res = null;
  const matchArr = text.match(/\S*<hi(?:(?!<\/hi>)[\s\S])*<\/hi>\S*|\S+/g) || [];
  const matchIdx = findIndex(matchArr, word => word && word.indexOf('<hi') !== -1);

  if (matchIdx !== -1) {
    const sliced = matchArr.slice(Math.max(matchIdx - BFR, 0), Math.min(matchIdx + AFTR + 1, matchArr.length));

    res = `{...${sliced.join(' ')}...}`;
  }

  if (hit === 'claims' && res) {
    //remove <br/> tags for Claims hit
    res = res.replace(/<br\/>/g, '');
  }

  return res;
}, hashFn);

const checkAndFormatIndexTermsHit = memoize(keywords => {
  if (!keywords) {
    return null;
  }

  const BFR = 1; // count of phrases before match
  const AFTR = 1; // count of phrases after match

  let res = null;
  let matchIdx;

  const highlighted = find(keywords, keyword => {
    matchIdx = findIndex(getValueByNs(keyword, 'value', []), val => val && val.indexOf('<hi') !== -1);
    return matchIdx !== -1;
  });

  if (highlighted) {
    const matchArr = highlighted.value;
    const sliced = matchArr.slice(Math.max(matchIdx - BFR, 0), Math.min(matchIdx + AFTR + 1, matchArr.length));

    // Add bold label if match is at 0 position
    res = `{...${matchIdx === 0 ? `<b>${highlighted.type}:</b> ` : ''}${sliced.join(', ')}...}`;
  }

  return res;
}, hashFn);

const DocumentHitsFormat = {
  checkAndFormatHit,
  checkAndFormatIndexTermsHit,
};

export default DocumentHitsFormat;
